import { Module } from '@nestjs/common';
import { AuditModule } from 'src/audit/audit.module';
import { ContabilidadModule } from 'src/contabilidad/contabilidad.module';
import { VendedoresCobradoresModule } from 'src/vendedores-cobradores/vendedores-cobradores.module';
import { ClientesModule } from 'src/clientes/clientes.module';
import { KudeModule } from 'src/kude/kude.module';
import { LotesModule } from 'src/lotes/lotes.module';
import { MiddlewareSifenModule } from 'src/middleware-sifen/middleware-sifen.module';
import { PersonasModule } from 'src/personas/personas.module';
import { QueuesModule } from 'src/queues/queues.module';
import { ReversionCajaModule } from 'src/tesoreria/reversion-caja.module';
import { EcommerceNotificationsModule } from 'src/ecommerce/notifications/ecommerce-notifications.module';
import { ListaPreciosModule } from 'src/lista-precios/lista-precios.module';
import { MonedasModule } from 'src/monedas/monedas.module';
import { winstonConfig } from '../common/logger/winston.config';
import { FacturasController } from './facturas.controller';
import { FacturasService } from './facturas.service';
import { SifenPayloadModule } from './sifen-payload.module';

@Module({
  controllers: [FacturasController],
  providers: [FacturasService],
  imports: [
    ClientesModule,
    PersonasModule,
    MiddlewareSifenModule,
    QueuesModule,
    KudeModule,
    LotesModule,
    AuditModule,
    ContabilidadModule,
    VendedoresCobradoresModule,
    SifenPayloadModule,
    EcommerceNotificationsModule,
    ListaPreciosModule,
    ReversionCajaModule,
    MonedasModule,
  ],
  exports: [FacturasService],
})
export class FacturasModule {}
